/*
 * @Author: tangke
 * @Date: 2019-02-16 17:57:17
 * @Last Modified by: others
 * @Last Modified time: 2019-02-16 19:02:02
 * 导航栏个人信息面板下Teaching Points的弹窗
 */
 <template>
  <v-dialog v-model="pointsData.dialog"
            width="800">
    <v-card class="blue-title">
      <v-card-title class="headline text-xs-center font-weight-bold"
                    primary-title>
        <v-spacer></v-spacer>
        <img :src="vector">&nbsp;
        Teaching Points and Tutor Level System
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <p>In Acadsoc, tutors can earn teaching points after every finished class or special projects. Good ratings from the students or parents can gain you extra points. However, unpunctuality or unfulfillment of your appointed schedule will make your efforts in vain.</p>
        <p>In the beginning, every tutor starts from a D level. After getting certain teaching points, they will be levelled up to C, B and A level. Every time when you are striding over to a new level, say D to C, you will be awarded a certificate, possibly a salary raise, and more benefits.</p>
      </v-card-text>
      <v-card-text>
        <v-data-table :headers="headers"
                      :items="desserts"
                      hide-actions
                      class="common-table">
          <template slot="items"
                    slot-scope="props">
            <td class="blue-title">{{ props.item.concern }}</td>
            <td class="blue-title" v-html="props.item.points"></td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import vector from '@/assets/img/common/vector.png'
export default {
  name: 'points',
  props: {
    pointsData: {
      dialog: false
    }
  },
  data: () => ({
    headers: [
      {
        text: 'Data in concern',
        align: 'left',
        sortable: false,
        value: 'concern'
      },
      {
        text: 'Points gained',
        align: 'left',
        sortable: false,
        value: 'points'
      }
    ],
    desserts: [
      {
        concern: 'Completed class',
        points: '+0.2 points'
      }, {
        concern: 'Completed weekend class',
        points: '+0.3 points'
      }, {
        concern: '5 star rating',
        points: '+2 points'
      }, {
        concern: '4 star rating',
        points: '+1 points'
      }, {
        concern: 'Cancellation',
        points: '-2 points'
      }, {
        concern: 'Absence',
        points: '-20 points'
      }, {
        concern: 'Complaint',
        points: '-10 points'
      }, {
        concern: 'Project Points',
        points: 'By DS'
      }, {
        concern: 'Completed Material Training',
        points: 'By DS'
      }, {
        concern: 'Tutor Referral Program',
        points: 'By DS'
      }, {
        concern: 'Teaching material correction',
        points: 'By DS'
      }, {
        concern: 'Enrolment',
        points: 'removed (For top tutors, please note there are<br/>newstructures  for the evaluation of trial classes)'
      }
    ],
    vector:vector
  }),
  methods: {
    show () {
      this.pointsData.dialog = true
    }
  }

}
</script>
<style lang="scss" scoped>
.blue-title{
  @include font_color($font-color-theme);

}
</style>
